import { useLocale } from 'next-intl';
import { useMemo } from 'react';
import { IntlFormatter } from '@monofront/business/utils';

const mapNextLocaleToIntlLocale = (nextLocale: string) => {
  const [language, region] = nextLocale.split('-');

  return `${language}-${region ? region.toUpperCase() : language}`;
};

const formatterCache = new Map<string, IntlFormatter>();

type UseIntlFormatterProps = {
  trailingZeroDisplay?: 'auto' | 'stripIfInteger';
};

export const useIntlFormatter = ({
  trailingZeroDisplay = 'stripIfInteger',
}: UseIntlFormatterProps = {}) => {
  const locale = useLocale();
  const formatter = useMemo(() => {
    const cacheKey = `${locale}-${trailingZeroDisplay}`;

    let formatter = formatterCache.get(cacheKey);

    if (!formatter) {
      formatter = new IntlFormatter(mapNextLocaleToIntlLocale(locale), {
        trailingZeroDisplay,
      });

      formatterCache.set(cacheKey, formatter);
    }

    return formatter;
  }, [locale]);

  return formatter;
};
